import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { ApolloLink } from '@apollo/client';
import { InMemoryCache } from '@apollo/client/cache';
import { ApolloClient } from '@apollo/client/core';
import { CachePersistor } from 'apollo-cache-persist';
import { useCallback, useEffect, useMemo, useState } from 'react';
import attachClient from '@magento/peregrine/lib/Apollo/attachClientToStore';
import { clearCartDataFromCache } from '@magento/peregrine/lib/Apollo/clearCartDataFromCache';
import { clearCustomerDataFromCache } from '@magento/peregrine/lib/Apollo/clearCustomerDataFromCache';
import { CACHE_PERSIST_PREFIX } from '@magento/peregrine/lib/Apollo/constants';
import getLinks from '@magento/peregrine/lib/Apollo/links';
import typePolicies from '@magento/peregrine/lib/Apollo/policies';
import { BrowserPersistence } from '@magento/peregrine/lib/util';
var isServer = !globalThis.document;
var storage = new BrowserPersistence();
var urlHasStoreCode = process.env.USE_STORE_CODE_IN_URL === 'true';
export var useAdapter = function useAdapter(props) {
  var apiUrl = props.apiUrl,
      configureLinks = props.configureLinks,
      origin = props.origin,
      store = props.store,
      styles = props.styles;
  var storeCode = storage.getItem('store_view_code') || STORE_VIEW_CODE;
  var basename = urlHasStoreCode ? "/".concat(storeCode) : null;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      initialized = _useState2[0],
      setInitialized = _useState2[1];

  var apiBase = useMemo(function () {
    return apiUrl || new URL('/graphql', origin).toString();
  }, [apiUrl, origin]);
  var apolloLink = useMemo(function () {
    var links = getLinks(apiBase);

    if (configureLinks) {
      links = configureLinks(links, apiBase);
    }

    return ApolloLink.from(Array.from(links.values()));
  }, [apiBase, configureLinks]);
  var createApolloClient = useCallback(function (cache, link) {
    return new ApolloClient({
      cache: cache,
      link: link,
      ssrMode: isServer
    });
  }, []);
  var createCachePersistor = useCallback(function (storeCode, cache) {
    return isServer ? null : new CachePersistor({
      key: "".concat(CACHE_PERSIST_PREFIX, "-").concat(storeCode),
      cache: cache,
      storage: globalThis.localStorage,
      debug: process.env.NODE_ENV === 'development'
    });
  }, []);
  var clearCacheData = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client, cacheType) {
      var storeCode, _iterator, _step, _store, existingStorePersistor, storeCache, storeClient;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              storeCode = storage.getItem('store_view_code') || 'default'; // Clear current store

              if (!(cacheType === 'cart')) {
                _context.next = 6;
                break;
              }

              _context.next = 4;
              return clearCartDataFromCache(client);

            case 4:
              _context.next = 9;
              break;

            case 6:
              if (!(cacheType === 'customer')) {
                _context.next = 9;
                break;
              }

              _context.next = 9;
              return clearCustomerDataFromCache(client);

            case 9:
              // Clear other stores
              _iterator = _createForOfIteratorHelper(AVAILABLE_STORE_VIEWS);
              _context.prev = 10;

              _iterator.s();

            case 12:
              if ((_step = _iterator.n()).done) {
                _context.next = 31;
                break;
              }

              _store = _step.value;

              if (!(_store.store_code !== storeCode)) {
                _context.next = 29;
                break;
              }

              // Get saved data directly from local storage
              existingStorePersistor = globalThis.localStorage.getItem("".concat(CACHE_PERSIST_PREFIX, "-").concat(_store.store_code)); // Make sure we have data available

              if (!(existingStorePersistor && Object.keys(existingStorePersistor).length > 0)) {
                _context.next = 29;
                break;
              }

              storeCache = new InMemoryCache(); // Restore available data

              storeCache.restore(JSON.parse(existingStorePersistor));
              storeClient = createApolloClient(storeCache, apolloLink);
              storeClient.persistor = isServer ? null : createCachePersistor(_store.store_code, storeCache); // Clear other store

              if (!(cacheType === 'cart')) {
                _context.next = 26;
                break;
              }

              _context.next = 24;
              return clearCartDataFromCache(storeClient);

            case 24:
              _context.next = 29;
              break;

            case 26:
              if (!(cacheType === 'customer')) {
                _context.next = 29;
                break;
              }

              _context.next = 29;
              return clearCustomerDataFromCache(storeClient);

            case 29:
              _context.next = 12;
              break;

            case 31:
              _context.next = 36;
              break;

            case 33:
              _context.prev = 33;
              _context.t0 = _context["catch"](10);

              _iterator.e(_context.t0);

            case 36:
              _context.prev = 36;

              _iterator.f();

              return _context.finish(36);

            case 39:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[10, 33, 36, 39]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [apolloLink, createApolloClient, createCachePersistor]);
  var apolloClient = useMemo(function () {
    var storeCode = storage.getItem('store_view_code') || 'default';
    var client = createApolloClient(preInstantiatedCache, apolloLink);
    var persistor = isServer ? null : createCachePersistor(storeCode, preInstantiatedCache);
    client.apiBase = apiBase;
    client.persistor = persistor;
    client.clearCacheData = clearCacheData;
    return client;
  }, [apiBase, apolloLink, clearCacheData, createApolloClient, createCachePersistor]);
  var getUserConfirmation = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(message, callback) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(typeof globalThis.handleRouteChangeConfirmation === 'function')) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", globalThis.handleRouteChangeConfirmation(message, callback));

            case 2:
              return _context2.abrupt("return", callback(globalThis.confirm(message)));

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }(), []);
  var apolloProps = {
    client: apolloClient
  };
  var reduxProps = {
    store: store
  };
  var routerProps = {
    basename: basename,
    getUserConfirmation: getUserConfirmation
  };
  var styleProps = {
    initialState: styles
  }; // perform blocking async work here

  useEffect(function () {
    if (initialized) return; // immediately invoke this async function

    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return apolloClient.persistor.restore();

            case 2:
              _context3.next = 4;
              return attachClient(apolloClient);

            case 4:
              // mark this routine as complete
              setInitialized(true);

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }, [apolloClient, initialized]);
  return {
    apolloProps: apolloProps,
    initialized: initialized,
    reduxProps: reduxProps,
    routerProps: routerProps,
    styleProps: styleProps,
    urlHasStoreCode: urlHasStoreCode
  };
};
/**
 * To improve initial load time, create an apollo cache object as soon as
 * this module is executed, since it doesn't depend on any component props.
 * The tradeoff is that we may be creating an instance we don't end up needing.
 */

var preInstantiatedCache = new InMemoryCache({
  // POSSIBLE_TYPES is injected into the bundle by webpack at build time.
  possibleTypes: POSSIBLE_TYPES,
  typePolicies: typePolicies
});